import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { AddColorToCollectionButton } from "./components/add-color-to-collection/add-button";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";

const AddColorToCollectionContext = createContext();

export const useAddColorToCollection = () =>
  useContext(AddColorToCollectionContext);

function AddColorToCollectionContextProvider({ data, children }) {
  return (
    <AddColorToCollectionContext.Provider value={data}>
      {children}
    </AddColorToCollectionContext.Provider>
  );
}

function AddColorToCollectionRenderer() {
  const elements = document.querySelectorAll(".react-add-color-to-collection");
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for AddColorToCollection"
      );
    }
    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <AddColorToCollectionContextProvider data={initialProps}>
            <AddColorToCollectionButton />
          </AddColorToCollectionContextProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initAddColorToCollection = () => {
  if (document.readyState !== "loading") {
    AddColorToCollectionRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", AddColorToCollectionRenderer);
  }
};
